import {
  Box,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Dialog,
  DialogContent,
} from '@mui/material';
import Proptypes from 'prop-types';
import { useState } from 'react';

import StartPackFileUpload from '../common/StartPackFileUpload';
import { api as stockApi } from '../../store/domains/stock';
import StartPackFormText from '../common/StartPackFormText';
import { a11yProps, TabPanel } from '../TabPanel';
import StartPackForm from '../common/StartPackForm';

function StartPackRangeDialog({ open, handleClose, isTransfer }) {
  const [value, setValue] = useState(0);
  const [selectValue, setSelectValue] = useState('');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeSelect = (event) => {
    setSelectValue(event.target.value);
  };
  const { data: hubList, isLoading: hubListLoading } = stockApi.useGetHubList();

  if (hubListLoading) {
    return <CircularProgress />;
  }
  return (
    <Dialog maxWidth="sm" open={open} onClose={handleClose} fullWidth>
      <DialogContent
        sx={{
          minHeight: '27rem',
        }}
      >
        <FormControl fullWidth>
          <InputLabel id="hub-label">Hub</InputLabel>
          <Select labelId="hub-label" id="hub" label="Hub" value={selectValue} onChange={handleChangeSelect}>
            {hubList?.map(({ hubId, title }) => (
              <MenuItem key={hubId} value={hubId}>
                {title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Range" {...a11yProps(0)} />
            <Tab label="File" {...a11yProps(1)} />
            <Tab label="Text" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <StartPackForm isTransfer={isTransfer} hubId={selectValue} handleClose={handleClose} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <StartPackFileUpload isTransfer={isTransfer} hubId={selectValue} handleClose={handleClose} />
        </TabPanel>{' '}
        <TabPanel value={value} index={2}>
          <StartPackFormText isTransfer={isTransfer} hubId={selectValue} handleClose={handleClose} />
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

StartPackRangeDialog.propTypes = {
  open: Proptypes.bool,
  handleClose: Proptypes.func,
  isTransfer: Proptypes.bool,
};

export default StartPackRangeDialog;
